<template>
  <v-app>
    <v-main>
      <router-view></router-view>
    </v-main>
    <notifications position="bottom right" :speed='1200'/>

    <v-overlay
        :opacity="1"
        :value="loadingPage"
    >
      <v-progress-circular indeterminate size="96">
        Loading...
      </v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>

import store from "@/store";

export default {
  name: 'App',
  computed: {
    loadingPage: () => store.state.pageLoading
  }
};
</script>

<style>
.background {
  background-image: url('./assets/images/background.jpg');
  background-repeat: repeat-y;
}
</style>